module.exports = __webpack_public_path__ + "static/img/logo105.104af1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo105.png
// module id = nH5E
// module chunks = 1